import { Component, Input } from '@angular/core';
import { ColumnSettings } from '../../common/models';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'number-editor',
  templateUrl: './number-editor.component.html',
  styleUrls: ['./number-editor.component.scss'],
  imports: [FormsModule]
})
export class NumberEditorComponent {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;
}
